"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorView = void 0;
const React = require("react");
const ConfigurationService_1 = require("../../../services/ConfigurationService");
const CoreContext_1 = require("../../../contexts/CoreContext");
const TranslationService_1 = require("../../../services/TranslationService");
const Translate_1 = require("../Translate");
const View_1 = require("../View");
const somethingWentWrongImg = require("../../../images/v2/something_went_wrong.svg");
require("./ErrorView.scss");
const ErrorViewContent = ({ helpUrl, errorTitle }) => {
    const titleRef = React.useRef(null);
    React.useEffect(() => {
        var _a;
        // Update page title for screen readers and browser tab
        document.title = `${errorTitle} - Microsoft Teams`;
        // Move focus to the error heading for screen reader announcement
        (_a = titleRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [errorTitle]);
    return (React.createElement(View_1.View, { className: "errorView", role: "main", "aria-labelledby": "error-title" },
        React.createElement("div", { className: "container" },
            React.createElement("header", { className: "header" }, "Microsoft Teams"),
            React.createElement("div", { className: "content", role: "alert", "aria-live": "assertive" },
                React.createElement("img", { className: "illustration", src: somethingWentWrongImg, alt: "", role: "presentation" }),
                React.createElement("h1", { id: "error-title", className: "title", ref: titleRef, tabIndex: -1 },
                    React.createElement(Translate_1.Translate, { i18n: "hdr_couldnt_find_other" })),
                React.createElement("p", { className: "message" },
                    React.createElement(Translate_1.Translate, { i18n: "txt_try_refresh_page" })),
                React.createElement("a", { className: "helpLink", href: helpUrl, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement(Translate_1.Translate, { i18n: "txt_get_more_help" }))))));
};
const ErrorView = () => {
    const helpUrl = ConfigurationService_1.configurationService.getConfig().urls.absoluteUrls.downloadHelp;
    return (React.createElement(CoreContext_1.CoreContextConsumer, null, ({ language, languageBundle }) => {
        const errorTitle = TranslationService_1.default.translate("hdr_couldnt_find_other", languageBundle, language);
        return React.createElement(ErrorViewContent, { helpUrl: helpUrl, errorTitle: errorTitle });
    }));
};
exports.ErrorView = ErrorView;
